import { FC } from "react";

import { GraphNode } from "../graph.types.ts";

import { GraphAlertNodePassiveModal } from "./GraphAlertNodePassiveModal.tsx";
import { GraphCaseNodePassiveModal } from "./GraphCaseNodePassiveModal.tsx";
import { GraphElementNodePassiveModal } from "./GraphElementNodePassiveModal.tsx";
import { GraphIdentifierNodePassiveModal } from "./GraphIdentifierNodePassiveModal.tsx";

type GraphNodePassiveModalProps = {
  node: GraphNode;
  onClose: () => void;
};

export const GraphNodePassiveModal: FC<GraphNodePassiveModalProps> = ({ node, onClose }) => {
  const data = node.data();

  switch (data.type) {
    case "case":
      return <GraphCaseNodePassiveModal data={data} onClose={onClose} />;

    case "case-alert":
      return <GraphAlertNodePassiveModal data={data} onClose={onClose} />;

    case "element":
      return <GraphElementNodePassiveModal data={data} onClose={onClose} />;

    case "identifier":
      return <GraphIdentifierNodePassiveModal data={data} onClose={onClose} />;

    default:
      return null;
  }
};
